import pluralize from 'pluralize';
import sdk from '../../../sdk';
import Logger from '../../../services/Logger';
import localization from '../../../shared/strings';
import * as utils from '../../../shared/utils';
import Toast from '../../../components/Toast';
import TYPES from '../../action-types';
import { showDialog } from '../../../components/dialog';
import { navigate, reloadCurrentPage } from '../../../helpers/history';
import CONSTANTS from '../../../shared/constants';

const { PASSWORD_STARS } = CONSTANTS;

/**
 * Change sharing settings
 * @param {string[]} ids - asset ids
 * @param {Object} data - { key: value }
 */
const changeShare = (ids, data) => async (dispatch) => {
  try {
    /** Remove unneeded fields */
    const {
      // eslint-disable-next-line no-unused-vars
      updatedAt, useGdPdfViewer, isProtected, password, ...dataToSave
    } = data;
    /** Don't update password if it is the placeholder */
    if (password !== PASSWORD_STARS) dataToSave.password = password;

    dispatch({ type: TYPES.ASSETS.SHARE.START });

    const { data: response } = await sdk.assets.setSingleSharingSettings(ids, dataToSave);
    const { errors = {} } = response;

    if (errors.notAllowed) {
      Toast(
        `Changing settings for ${pluralize('asset', errors.notAllowed, true)} is not allowed.`,
        { type: 'error', autoClose: false },
      );
    }

    dispatch({
      type: TYPES.ASSETS.SHARE.COMPLETE,
      payload: {
        assetIds: ids,
        data: dataToSave,
      },
    });
  } catch (error) {
    const errorStatus = utils.getStatusFromResponceError(error);
    const subcode = utils.getDataFromResponceError(error, 'subcode');
    const { ERROR_PLAN_LIMIT } = localization.DIALOGS;

    if (errorStatus === 409 && subcode === 'AssetSharingLimitExceededError') {
      showDialog({
        title: ERROR_PLAN_LIMIT.TITLE,
        text: ERROR_PLAN_LIMIT.TEXT,
        textBtnOk: ERROR_PLAN_LIMIT.OK_TEXT,
        textBtnCancel: null,
        async onOk() {
          navigate('/billing?tab=overview');
        },
      });
    } else if (errorStatus === 403) {
      showDialog({
        title: 'Some assets can\'t be shared',
        text: 'You don\'t have permission to share some of the selected assets. Deselect these assets to continue.',
        textBtnCancel: 'Close',
        textBtnOk: null,
        onCancel: () => {
          Logger.log('User', 'SomeAssetsCantBeSharedModalClosed');
        },
      });
      Logger.log('UI', 'SomeAssetsCantBeSharedModalShown');
    } else {
      Toast(localization.DETAILS.textCantSetSingleAssetSettings, {
        autoClose: false, type: 'error', onOk: reloadCurrentPage, btnOkValue: localization.HISTORY.textBtnRefresh,
      });
    }

    dispatch({ type: TYPES.ASSETS.SHARE.FAILED, error });
    Logger.error(new Error('Can not set single sharing settings'), { error }, [
      'ShareAssetFailed',
      { errorMessage: (error && error.message) || 'NoMessage' },
    ]);
  }
};
export default changeShare;
